import styled, { keyframes } from "styled-components";

const animationModal = keyframes`
		from{
				transform: translateY(1000%);
		}
		to{
				transform: translateY(0%);
		}
`;

export const Container = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9901;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.5);
`;

export const Content = styled.div`
	width: 95%;
	max-width: 600px;
	background-color: #fff;
	border-radius: 8px;
	padding: 1rem;
	max-height: 90%;
	transform: translateY(1000%);

	animation: ${animationModal} 0.3s ease-in-out forwards;

	display: flex;
	flex-direction: column;
`;

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
	color: #393939;
	position: relative;

	button {
		background: none;
		display: flex;
		align-items: center;
		justify-content: center;
		border: none;
		color: #393939;
		font-size: 1.1rem;
		position: absolute;
		right: 0;
		top: 0;
	}

	h1 {
		text-align: center;
		font-size: 1.3rem;
	}
`;

export const Main = styled.div`
	margin-top: 1rem;
	form {
		width: 100%;
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	gap: 0.75rem;

	@media (max-width: 500px) {
		flex-direction: column;
	}
`

export const AlertContainer = styled.div`
	background-color: rgba(238, 255, 0, 0.3);
	border: 1px solid #eeff00ff;
	padding: 1rem;
	border-radius: 8px;
`

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	label {
		font-weight: 500;
		color: #393939;
	}
`

export const ErrorMessage = styled.span`
	color: #e74c3c;
	font-size: 0.875rem;
	margin-top: 0.25rem;
`